<template>
  <basic-portlet title="Author Details" :no-shadow="borderless">
    <div class="row">
      <div class="col-12 col-md-6">
        <div class="form-group">
          <label for="author"><strong>Author * <span id="author_tooltip" class="ml-2 la la-question-circle" /></strong></label>
          <b-tooltip target="author_tooltip" triggers="hover">
            <div v-sanitise="tooltips.author_tooltip" />
          </b-tooltip>
          <input id="author"
                 v-model="podcast.itunes_detail.author"
                 v-validate="'required'"
                 data-vv-scope="author-details-form"
                 name="Author"
                 type="text"
                 class="form-control"
                 placeholder="John Doe">
          <p v-show="errors.has('Author', 'author-details-form')" class="help text-ss-danger">
            {{ errors.first('Author', 'author-details-form') }}
          </p>
        </div>
        <div class="form-group">
          <label for="owner"><strong>Owner Name * <span id="owner_name_tooltip" class="ml-2 la la-question-circle" /></strong></label>
          <b-tooltip target="owner_name_tooltip" triggers="hover">
            <div v-sanitise="tooltips.owner_name_tooltip" />
          </b-tooltip>
          <input id="owner"
                 v-model="podcast.itunes_detail.owner_name"
                 v-validate="'required'"
                 data-vv-scope="author-details-form"
                 name="Owner"
                 type="text"
                 class="form-control"
                 placeholder="John Doe">
          <p v-show="errors.has('Owner', 'author-details-form')" class="help text-ss-danger">
            {{ errors.first('Owner', 'author-details-form') }}
          </p>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="form-group">
          <label for="copyright"><strong>Copyright</strong></label>
          <input id="copyright"
                 v-model="podcast.itunes_detail.copyright"
                 data-vv-scope="author-details-form"
                 name="Copyright"
                 type="text"
                 class="form-control"
                 placeholder="SharpStream Ltd. 2022">
        </div>
        <div class="form-group">
          <label for="owner_email"><strong>Owner Email * <span id="owner_email_tooltip" class="ml-2 la la-question-circle" /></strong></label>
          <b-tooltip target="owner_email_tooltip" triggers="hover">
            <div v-sanitise="tooltips.owner_email_tooltip" />
          </b-tooltip>
          <input id="owner_email"
                 v-model="podcast.itunes_detail.owner_email"
                 v-validate="'required|email'"
                 data-vv-scope="author-details-form"
                 name="Owner Email"
                 type="text"
                 class="form-control"
                 placeholder="john.doe@gmail.com">
          <p v-show="errors.has('Owner Email', 'author-details-form')" class="help text-ss-danger">
            {{ errors.first('Owner Email', 'author-details-form') }}
          </p>
        </div>
      </div>
    </div>
  </basic-portlet>
</template>

<script>
import BasicPortlet from "VueComponents/BasicPortlet";
import PodcastValidateMixin from "VueMixins/PodcastValidateMixin";
import { mapWritableState } from 'pinia';
import { usePodcastManageStore } from "VueStore/app/podcastManage";
import TooltipsMixin from "VueMixins/TooltipsMixin";

export default {
  components: { BasicPortlet },
  mixins: [PodcastValidateMixin, TooltipsMixin],
  props: {
    borderless: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapWritableState(usePodcastManageStore, ['podcast']),
  },
};
</script>
